import * as React from 'react';
import { Boundary } from './hooks';
import { NullableReactStateType, ReactStateType } from './Map';
import { MAP_STYLE_LIST } from './style';

export interface MapSettingsContextType {
  mapStyleHook: ReactStateType<number>;
  userPolyModeHook: ReactStateType<boolean>;
  userAdressesModeHook: ReactStateType<boolean>;
  strokeBoundaryModeHook: NullableReactStateType<Boundary>;
  fillBoundaryModeHook: NullableReactStateType<Boundary>;
  displayCompaniesHook: ReactStateType<boolean>;
}

const defaultBehaviour: MapSettingsContextType = {
	mapStyleHook: [0, () => undefined],
	userPolyModeHook: [false, () => undefined],
	userAdressesModeHook: [false, () => undefined],
	strokeBoundaryModeHook: [undefined, () => undefined],
	fillBoundaryModeHook: [undefined, () => undefined],
	displayCompaniesHook: [false, () => undefined]
};

export const MapSettingsContext = React.createContext<MapSettingsContextType>(
	defaultBehaviour
);

const mapStyleVar = parseInt(localStorage.getItem('mapStyle') ?? '0');

export function MapSettingsProvider(props: { children: React.ReactNode }) {
	const userPolyModeHook = React.useState<boolean>(false);
	const userAdressesModeHook = React.useState<boolean>(false);
	const strokeBoundaryModeHook = React.useState<Boundary>();
	const fillBoundaryModeHook = React.useState<Boundary>();
	const displayCompaniesHook = React.useState<boolean>(true);
	const mapStyleHook = React.useState<number>(MAP_STYLE_LIST[mapStyleVar] ? mapStyleVar : 0);

	return (
		<MapSettingsContext.Provider
			value={{
				userPolyModeHook,
				userAdressesModeHook,
				strokeBoundaryModeHook,
				fillBoundaryModeHook,
				displayCompaniesHook,
				mapStyleHook
			}}
		>
			{props.children}
		</MapSettingsContext.Provider>
	);
}
